import { VisitReportsComponent } from './components/visit-reports/visit-reports.component';
import { ReportsTemplatesComponent } from './components/reports-templates/reports-templates.component';
import { ReportsLoginComponent } from './components/reports-login/reports-login.component';
import { ReportsFinanceComponent } from './components/reports-finance/reports-finance.component';
import { ReportsInventoryComponent } from './components/reports-inventory/reports-inventory.component';
import { ReportsVisitsComponent } from './components/reports-visits/reports-visits.component';
import { ReportsQuestionaireComponent } from './components/reports-questionaire/reports-questionaire.component';
import { ReportsOpportunityComponent } from './components/reports-opportunity/reports-opportunity.component';
import { ReportsLeadsComponent } from './components/reports-leads/reports-leads.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountReportsComponent } from './components/account-reports/account-reports.component';
import { CaseReportsComponent } from './components/case-reports/case-reports.component';
import { ActivityReportsComponent } from './components/activity-reports/activity-reports.component';
import { ReportsComponent } from './reports.component';
import { ReportsUserActivityComponent } from './components/reports-user-activity/reports-user-activity.component';
import { ReportsAuditComponent } from './components/reports-audit/reports-audit.component';
import {SavedSearchReportComponent} from './components/saved-search-report/saved-search-report.component';


const routes: Routes = [
    {
        path: '', component: ReportsComponent,
        children: [
            { path: 'leads/:type', component: ReportsLeadsComponent },
            { path: 'opportunity/:type', component: ReportsOpportunityComponent },
            { path: 'user-activity/:type', component: ReportsUserActivityComponent },
            { path: 'audit/:type', component: ReportsAuditComponent },
            { path: 'questionaire/:type', component: ReportsQuestionaireComponent },
            { path: 'visits/:type', component: VisitReportsComponent },
            { path: 'visits-v2/:type', component: ReportsVisitsComponent },
            { path: 'inventory/:type', component: ReportsInventoryComponent },
            { path: 'finance/:type', component: ReportsFinanceComponent },
            { path: 'login/:type', component: ReportsLoginComponent },
            { path: 'activity/:type', component: ActivityReportsComponent },
            { path: 'accounts/:type', component: AccountReportsComponent },
            { path: 'cases/:type', component: CaseReportsComponent },
            { path: 'template/:type', component: ReportsTemplatesComponent },
            { path: 'savedsearch-report/:id', component: SavedSearchReportComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReportsRoutingModule { }
